import { Button, Typography } from 'antd';
import { Link } from 'react-router-dom';

import styles from './index.module.scss';
import { FC } from 'react';

type HeaderButtonProps = {
	text: string;
	link: string;
	title: string;
};

export const HeaderButton: FC<HeaderButtonProps> = ({ text, link, title }) => {
	return (
		<div className={styles.headerButton}>
			<Typography.Text className={styles.text} type="secondary">
				{text}
			</Typography.Text>
			<Link to={link}>
				<Button type="default" className="white-btn">
					{title}
				</Button>
			</Link>
		</div>
	);
};
